import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

/* export interface Sklop {
  value: string;
  viewValue: string;
} */

/* export interface Spremenljivka {
  value: string;
  viewValue: string;
} */

export interface Regija {
  value: string;
  viewValue: string;
}

export interface Sezona {
  value: string;
  viewValue: string;
}

export interface TempKazalniki {
  value: string;
  viewValue: string;
}

export interface PadKazalniki {
  value: string;
  viewValue: string;
}

export interface IzjemnePadavine {
  value: string;
  viewValue: string;
}

@Component({
  selector: 'app-filter6',
  templateUrl: './filter6.component.html',
  styleUrls: ['./filter6.component.css']
})
export class Filter6Component implements OnInit {
  name: string;

  selected1 = undefined;
  selected2 = undefined;
  selected3 = undefined;
  selected4 = undefined;
  selected5 = undefined;
  selected6 = undefined;
  selected7 = undefined;


  public izbira = [
    {value: 1, viewValue: 'Temperatura'},
    {value: 2, viewValue: 'Padavine'},
    {value: 3, viewValue: 'Vodna bilanca'}
  ];

  /* spremenljivka: Spremenljivka[] = [
    {value: 'spr-0', viewValue: 'Povprečna temperatura'},
    {value: 'spr-1', viewValue: 'Najvišja temperatura'},
    {value: 'spr-2', viewValue: 'Najnižja temperatura'},
    {value: 'spr-3', viewValue: 'Temperaturni kazalniki'},
    {value: 'spr-5', viewValue: 'Višina padavin'},
    {value: 'spr-8', viewValue: 'Padavinski kazalniki'},
    {value: 'spr-7', viewValue: 'Trendi izjemnih padavin'},
    {value: 'spr-9', viewValue: 'Referenčna evapotranspiracija'},
    {value: 'spr-12', viewValue: 'Napajanje podzemnih voda'},
    {value: 'spr-13', viewValue: 'Trendi vodnega primanjkljaja'}
  ]; */

  regija: Regija[] = [
    {value: 'reg-0', viewValue: 'Slovenija'},
    {value: 'reg-1', viewValue: 'Posočje'},
    {value: 'reg-2', viewValue: 'Osrednja'},
    {value: 'reg-3', viewValue: 'Severovzhod'},
    {value: 'reg-4', viewValue: 'Jugozahod'},
    {value: 'reg-5', viewValue: 'Visokogorje'},
    {value: 'reg-6', viewValue: 'Prehodna'}
  ];

  sezona: Sezona[] = [
    {value: 'sezona-0', viewValue: 'Leto'},
    {value: 'sezona-1', viewValue: 'Zima'},
    {value: 'sezona-2', viewValue: 'Pomlad'},
    {value: 'sezona-3', viewValue: 'Poletje'},
    {value: 'sezona-4', viewValue: 'Jesen'},
  ];

  tempKazalniki: TempKazalniki[] = [
    {value: 'tmpKaz-0', viewValue: 'Kazalnik vročine pozitiven (EHF)'},
    {value: 'tmpKaz-3', viewValue: 'Magnituda vročinskega vala (HWMId)'},
    {value: 'tmpKaz-6', viewValue: 'Skupna dolžina toplih obdobij (WSDI)'},
    {value: 'tmpKaz-7', viewValue: 'Število toplih dni (SU)'},
    {value: 'tmpKaz-8', viewValue: 'Število vročih dni'},
    {value: 'tmpKaz-9', viewValue: 'Število tropskih noči (TR)'},
    {value: 'tmpKaz-10', viewValue: 'Kazalnik najtoplejših dni (TX90p)'},
    {value: 'tmpKaz-11', viewValue: 'Kazalnik mraza negativen (ECF)'},
    {value: 'tmpKaz-14', viewValue: 'Skupna dolžina hladnih obdobij (CSDI)'},
    {value: 'tmpKaz-15', viewValue: 'Število hladnih dni (FD)'},
    {value: 'tmpKaz-16', viewValue: 'Število ledenih dni (ID)'},
    {value: 'tmpKaz-17', viewValue: 'Kazalnik najhladnejših dni (TN10p)'}
  ];

  padKazalniki: PadKazalniki[] = [
    {value: 'padKaz-0', viewValue: 'Dolžina najdaljšega suhega obdobja v letu (CDD)'},
    {value: 'padKaz-1', viewValue: 'Dolžina najdaljšega mokrega obdobja v letu (CWD)'},
    {value: 'padKaz-2', viewValue: 'Letna višina padavin iz najbolj mokrih dni (R95pTOT)'},
    {value: 'padKaz-5', viewValue: 'Število dni na leto z več kot 10 mm padavin (R10mm)'},
    {value: 'padKaz-8', viewValue: 'Največja dnevna višina padavin (Rx1day)'},
    {value: 'padKaz-9', viewValue: 'Največja petdnevna višina padavin (Rx5day)'}
  ];

  izjemnePadavine: IzjemnePadavine[] = [
    {value: 'izjemnePadavine-0', viewValue: 'Največja enodnevna višina padavin'},
    {value: 'izjemnePadavine-1', viewValue: 'Največja tridnevna višina padavin'},
    {value: 'izjemnePadavine-2', viewValue: 'Največja petdnevna višina padavin'}
  ];

  defualtOption = null;
  public spremenljivka = [];

  selectDisabled3 = true;
  selectDisabled4 = true;
  selectDisabled5 = true;
  selectDisabled6 = true;
  selectDisabled7 = true;
  hidden3 = false;
  hidden4 = false;
  hidden5 = false;
  hidden6 = false;
  hidden7 = false;

  firstDropDownChanged(viewValue: any) {
    const obj = this.izbira[viewValue];
    console.log(obj);
    
    this.selected2 = undefined;
    this.selected3 = undefined;
    this.selected4 = undefined;
    this.selected5 = undefined;
    this.selected6 = undefined;
    this.selected7 = undefined;

    if (!obj) return;
    
    if (obj.value == 1) {
      this.spremenljivka = [
        {value: 'spr-0', viewValue: 'Povprečna temperatura'},
        {value: 'spr-1', viewValue: 'Najvišja temperatura'},
        {value: 'spr-2', viewValue: 'Najnižja temperatura'},
        {value: 'spr-3', viewValue: 'Temperaturni kazalniki'}
      ];
      this.selectDisabled3 = true;
      this.selectDisabled4 = true;
      this.selectDisabled5 = true;
      this.selectDisabled6 = true;
      this.selectDisabled7 = true;
      this.hidden3 = false;
      this.hidden4 = false;
      this.hidden5 = false;
      this.hidden6 = false;
      this.hidden7 = false;
    }
    
    else if (obj.value == 2) {
      this.spremenljivka = [
        {value: 'spr-5', viewValue: 'Višina padavin'},
        {value: 'spr-8', viewValue: 'Padavinski kazalniki'},
        {value: 'spr-7', viewValue: 'Trendi izjemnih padavin'}
      ];
      this.selectDisabled3 = true;
      this.selectDisabled4 = true;
      this.selectDisabled5 = true;
      this.selectDisabled6 = true;
      this.selectDisabled7 = true;
      this.hidden3 = false;
      this.hidden4 = false;
      this.hidden5 = false;
      this.hidden6 = false;
      this.hidden7 = false;
    }

    else {
      this.spremenljivka = [
        {value: 'spr-9', viewValue: 'Referenčna evapotranspiracija'},
        {value: 'spr-12', viewValue: 'Napajanje podzemnih voda'},
        {value: 'spr-13', viewValue: 'Trendi vodnega primanjkljaja'}
      ];
      this.selectDisabled3 = true;
      this.selectDisabled4 = true;
      this.selectDisabled5 = true;
      this.selectDisabled6 = true;
      this.selectDisabled7 = true;
      this.hidden3 = false;
      this.hidden4 = false;
      this.hidden5 = false;
      this.hidden6 = false;
      this.hidden7 = false;
    }

    this.eventClicked1.emit(this.selected1);
    this.eventClicked2.emit(this.selected2);
    this.eventClicked3.emit(this.selected3);
    this.eventClicked4.emit(this.selected4);
    this.eventClicked5.emit(this.selected5);
    this.eventClicked6.emit(this.selected6);
    this.eventClicked7.emit(this.selected7);

  }
  
  secondDropDownChanged(value: any) {
    console.log(value);

    if (value == 'spr-3') {
      this.selectDisabled3 = false;
      this.selectDisabled4 = true;
      this.selectDisabled5 = true;
      this.selectDisabled6 = true;
      this.selectDisabled7 = true;
      this.hidden3 = true;
      this.hidden4 = false;
      this.hidden5 = false;
      this.hidden6 = false;
      this.hidden7 = false;
      this.tempKazalniki = this.tempKazalniki;
      this.selected4 = undefined;
      this.selected5 = undefined;
      this.selected6 = undefined;
      this.selected7 = undefined;
    }

    else if (value == 'spr-8') {
      this.selectDisabled3 = true;
      this.selectDisabled4 = false;
      this.selectDisabled5 = true;
      this.selectDisabled6 = true;
      this.selectDisabled7 = true;
      this.hidden3 = false;
      this.hidden4 = true;
      this.hidden5 = false;
      this.hidden6 = false;
      this.hidden7 = false;
      this.padKazalniki = this.padKazalniki;
      this.selected3 = undefined;
      this.selected5 = undefined;
      this.selected6 = undefined;
      this.selected7 = undefined;
    }

    else if (value == 'spr-9') {
      this.selectDisabled3 = true;
      this.selectDisabled4 = true;
      this.selectDisabled5 = true;
      this.selectDisabled6 = true;
      this.selectDisabled7 = false;
      this.hidden3 = false;
      this.hidden4 = false;
      this.hidden5 = false;
      this.hidden6 = false;
      this.hidden7 = true;
      this.sezona = this.sezona;
      this.selected3 = undefined;
      this.selected4 = undefined;
      this.selected5 = undefined;
      this.selected6 = undefined;
    }

    else if (value == 'spr-12' || value == 'spr-13') {
      this.selectDisabled3 = true;
      this.selectDisabled4 = true;
      this.selectDisabled5 = true;
      this.selectDisabled6 = true;
      this.selectDisabled7 = true;
      this.hidden3 = false;
      this.hidden4 = false;
      this.hidden5 = false;
      this.hidden6 = false;
      this.hidden7 = false;
      this.selected3 = undefined;
      this.selected4 = undefined;
      this.selected5 = undefined;
      this.selected6 = undefined;
      this.selected7 = undefined;
    }

    else if (value == 'spr-7' ) {
      this.selectDisabled3 = true;
      this.selectDisabled4 = true;
      this.selectDisabled5 = false;
      this.selectDisabled6 = false;
      this.selectDisabled7 = true;
      this.hidden3 = false;
      this.hidden4 = false;
      this.hidden5 = true;
      this.hidden6 = true;
      this.hidden7 = false;
      this.izjemnePadavine = this.izjemnePadavine;
      this.selected3 = undefined;
      this.selected4 = undefined;
      this.selected7 = undefined;
    }

    else {
      this.selectDisabled3 = true;
      this.selectDisabled4 = true;
      this.selectDisabled5 = true;
      this.selectDisabled6 = false;
      this.selectDisabled7 = true;
      this.hidden3 = false;
      this.hidden4 = false;
      this.hidden5 = false;
      this.hidden6 = true;
      this.hidden7 = false;
      this.selected3 = undefined;
      this.selected4 = undefined;
      this.selected5 = undefined;
      this.selected7 = undefined;
    }

    this.eventClicked2.emit(this.selected2);
    this.eventClicked3.emit(this.selected3);
    this.eventClicked4.emit(this.selected4);
    this.eventClicked5.emit(this.selected5);
    this.eventClicked6.emit(this.selected6);
    this.eventClicked7.emit(this.selected7);
    
  }

  thirdDropDownChanged(value: any) {
    console.log(value);
  }

  fourthDropDownChanged(value: any) {
    console.log(value);
  } 

  fifthDropDownChanged(value: any) {
    console.log(value);
  } 

  sixthDropDownChanged(value: any) {
    console.log(value);
  }

  seventhDropDownChanged(value: any) {
    console.log(value);
  }

  @Output() eventClicked1 = new EventEmitter<Event>();
  @Output() eventClicked2 = new EventEmitter<Event>();
  @Output() eventClicked3 = new EventEmitter<Event>();
  @Output() eventClicked4 = new EventEmitter<Event>();
  @Output() eventClicked5 = new EventEmitter<Event>();
  @Output() eventClicked6 = new EventEmitter<Event>();
  @Output() eventClicked7 = new EventEmitter<Event>();

  constructor(private router: Router,
    private route: ActivatedRoute) { }

  ngOnInit() {
  }

  onClick1(selected1: Event): void {
    this.eventClicked1.emit(selected1);
  }

  onClick2(selected2: Event): void {
    this.eventClicked2.emit(selected2);
  }

  onClick3(selected3: Event): void {
    this.eventClicked3.emit(selected3);
  }

  onClick4(selected4: Event): void {
    this.eventClicked4.emit(selected4);
  }

  onClick5(selected5: Event): void {
    this.eventClicked5.emit(selected5);
  }

  onClick6(selected6: Event): void {
    this.eventClicked6.emit(selected6);
  }

  onClick7(selected7: Event): void {
    this.eventClicked7.emit(selected7);
  }

}
